module.exports = __webpack_public_path__ + "img/jyl_icon_word.13d00e81.png";